import s from "./MainHeaderSearchResult.module.scss";
import MainHeaderStore from "../../../../../../../stores/MainHeaderStore";
import { MainHeaderSearchCollection } from "../../../../../MainHeaderSearchItem/ui/MainHeaderSearchCollection";
import FlowerLoader from "../../../../../../../../Icons/FlowerLoader";
import BoxIcon from "../../../../../../../../Icons/BoxIcon";
import { observer } from "mobx-react-lite";

interface Props {
  mainHeaderStore: MainHeaderStore;
}

export const MainHeaderSearchResult: React.FC<Props> = observer(
  ({ mainHeaderStore }) => {
    const isSearchStarting =
      mainHeaderStore?.searchItems?.collections?.length &&
      mainHeaderStore?.searchString !== "";
    return (
      mainHeaderStore.isSearchResultOpen && (
        <div className={s.wrapper}>
          {isSearchStarting ? (
            <div className={s.blocks}>
              <div className={s.block}>
                <div className={s.title}>Collections</div>
                {mainHeaderStore.searchItems.collections.map((item) => (
                  <div key={item.address}>
                    <MainHeaderSearchCollection
                      address={item.address}
                      headerStore={mainHeaderStore}
                      info={item}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className={s.noresult}>
              {mainHeaderStore.isLoading ? (
                <div className={s.loader}>
                  <FlowerLoader />
                </div>
              ) : (
                <>
                  <div className={s.noresult_img}>
                    <BoxIcon />
                  </div>
                  <div className={s.noresult_title}>Nothing was found</div>
                  <div className={s.noresult_text}>
                    Try changing the query and try again
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )
    );
  }
);
